import {urls as jsClientURLs} from '@apps-common/js-client';
import request, {setAppHeader} from '@apps-common/js-client/api/request';
import qs from 'qs';
import API_URLS from './urls.ts';

//js-client urls is a wrapper for Data API at this time
jsClientURLs.setBase(API_URLS.base);
// this injects the value as the base url for all requests
request.defaults.baseURL = API_URLS.base;

setAppHeader('acorns', [
  API_URLS.destinations,
  API_URLS.order,
  API_URLS.pdaAdmin,
  API_URLS.subscriptions,
]);

request.defaults.paramsSerializer = {
  serialize: params =>
    qs.stringify(params, {
      skipNulls: true,
      arrayFormat: 'repeat',
      allowEmptyArrays: false,
    }),
};

export {request};
